module.exports = __webpack_public_path__ + "img/Urban_Outfitters_logo.d54f9771.svg";